import { Fragment, h } from "preact";
import { useEffect, useLayoutEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import AppFooter from "./AppFooter.jsx";
import GlobalError from "./GlobalError.jsx";
import LinearLoadingIndicator from "./LinearLoadingIndicator.jsx";
import { classNames } from "../helpers.js";
import { setIsMobileView } from "../store/uiSlice.js";
import Toasts from "./Toasts.jsx";

const MOBILE_BREAKPOINT = 991;

export default function AppFocusLayout({
  closerAction,
  children,
  hideFooter,
  ornamented,
  unpadded,
  ...props
}) {
  const isMobileView = useSelector((state) => state.ui.isMobileView);
  const globalError = useSelector((state) => state.ui.globalError);
  const dispatch = useDispatch();
  let resizeTimeout = null;

  const loading = useSelector((state) => state.ui.loading);

  useLayoutEffect(() => {
    dispatch(setIsMobileView(window.innerWidth < MOBILE_BREAKPOINT));
  }, []);

  function onResize() {
    if (resizeTimeout) window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      dispatch(setIsMobileView(window.innerWidth < MOBILE_BREAKPOINT));
    }, 150);
  }

  useEffect(() => {
    if (props.title) {
      document.title = props.title;
    }
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  });

  return (
    <Fragment>
      {globalError && <GlobalError error={globalError} />}
      <div
        class={classNames(
          "app-focus-layout",
          isMobileView && "app-focus-layout--mobile-view",
          ornamented && "app-focus-layout--ornamented",
          unpadded && "app-focus-layout--unpadded",
          props.class
        )}
      >
        <div class="app-focus-layout__header app-focus-layout__header--sticky">
          <div class="app-focus-layout__top-line">
            <img src="/images/logo_icon.svg" width="48" height="48" />
            {closerAction}
          </div>
        </div>
        <Toasts />
        {(props.loading || loading) && (
          <LinearLoadingIndicator class="app-focus-layout__loading app-focus-layout__loading--with-sticky" />
        )}
        <main class="app-focus-layout__content app-focus-layout__content--with-sticky-header">
          {children}
        </main>
        {!hideFooter && (
          <footer class="app-focus-layout__footer">
            <AppFooter />
          </footer>
        )}
      </div>
    </Fragment>
  );
}
